import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-reddit',
  templateUrl: './reddit.component.html',
  styleUrls: ['./reddit.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedditIconComponent {}
